<div class="intro-banner-container">
  <sc-intro-banner [currentBanner]="currentBanner"></sc-intro-banner>

  <div class="close-container-button" (click)="hideBannerEvent.emit()">&times;</div>
</div>
